module.exports = __webpack_public_path__ + "fonts/Eva-Icons.ac165c67.woff2";